import { Currency } from 'core/payments/entities';

export enum FacebookEventNames {
  PURCHASE = 'Purchase',
  ADD_TO_CART = 'AddToCart',
  INITIATE_CHECKOUT = 'InitiateCheckout',
  PAGE_VIEW = 'PageView',
}

export type FacebookPurchaseParams = {
  ltvPredict: number;
  paymentId: string;
  currency: Currency;
  channelInfo?: string;
};

export type FacebookMethods = {
  revokeConsent: () => void;
  grantConsent: () => void;
  disableAutoConfig: (id: string) => void;
  init: (id: string) => void;
  track: (
    name: FacebookEventNames,
    params?: Record<string, unknown>,
    options?: { eventID: string },
  ) => void;
};
